import { useContext } from 'react'
import { LoginContext } from '../providers/loginProvider/LoginProvider'

const useLogin = () => {
  const loginContextValue = useContext<LoginContext | null>(LoginContext)
  return loginContextValue as LoginContext
}

export default useLogin
